/* eslint-disable import/order */
import { createGlobalStyle, css } from 'styled-components';

import 'tippy.js/dist/tippy.css';
import cssReset from './styled/cssReset';

const globalStyle = css`
  ${cssReset};

  html,
  body,
  #root {
    ${({ theme }) => theme.fonts.Satoshi};

    height: 100%;
  }

  body {
    color: ${({ theme }) => theme.colors.neutral.primaryNavy};
    background-color: ${({ theme }) => theme.colors.white};
    overflow-y: overlay;
    line-height: 1.3;
  }

  :where(
    a[href],
    button,
    [role='button'],
    [role='tab'],
    [type='checkbox'],
    [type='radio'],
    [tabindex]:not([tabindex='-1'])
  ):focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.neutral.lightNavy};
    outline-offset: 2px;
  }

  :where(
      a[href],
      button,
      [role='button'],
      [role='tab'],
      [type='checkbox'],
      [type='radio'],
      [tabindex]:not([tabindex='-1'])
    ):focus:not(:focus-visible) {
    outline: none;
  }

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border-width: 0;
  }

  .skip-link {
    position: fixed;
    top: -40px;
    left: 50%;
    transform: translateX(-50%);
    z-index: ${({ theme }) => theme.layers.overlay + 1};
    padding: 8px 12px;
    border-radius: 4px;
    background-color: ${({ theme }) => theme.colors.neutral.primaryNavy};
    color: ${({ theme }) => theme.colors.white};
    text-decoration: none;
  }

  .skip-link:focus-visible {
    top: 32px;
    outline: 2px solid ${({ theme }) => theme.colors.yellow.primary};
    outline-offset: 2px;
  }

  #main-content:focus {
    outline: none;
  }

  @media ${({ theme }) => theme.queries.maxDesktop} {
    .skip-link:focus-visible {
      top: 40px;
    }
  }

  // added because of issue with third-party cookie banner
  div#hs-eu-cookie-confirmation div#hs-eu-policy-wording > p > a {
    color: #272a5e;
    font-weight: 800 !important;
  }

  .tippy-box:has(.message-additional-participants-tooltip) {
    background-color: ${({ theme }) => theme.colors.neutral.darkestNavy};
    padding: 8px 16px;
    border-radius: 8px;

    text-align: left;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
    color: ${({ theme }) => theme.colors.neutral.lavenderWhite};

    span {
      font-weight: 700;
    }
  }
`;

export default createGlobalStyle`${globalStyle}`;
